module.exports = __webpack_public_path__ + "img/chevron-compact-right.6ad9d60e.svg";